import { render, staticRenderFns } from "./ProfileSharing.vue?vue&type=template&id=0ab6331c&scoped=true&"
import script from "./ProfileSharing.vue?vue&type=script&lang=js&"
export * from "./ProfileSharing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab6331c",
  null
  
)

export default component.exports